// import config from '../../../config';

/**
 * Powerup is type of Collectible managed by the CollectibleManager
 * Didn't make a true subclass because this is easier.
 *
 */
class ToggleButton extends Phaser.GameObjects.Image {
  /**
   * Start here making player class
   *
   * Need to start doing some device/canvas/webgl testing too.
   */
  constructor (params) {
    // console.log('new ToggleButton', params);
    super(params.scene, params.x, params.y, params.texture, 'on.png');

    this.params = params;
    this.scene = params.scene;
    this.id = params.id;
    this.x = params.x;
    this.y = params.y;
    this.texture = params.texture;
    this.isOn = params.isOn;
    this.onClick = params.onClick;
    this.onClickScope = params.onClickScope;
    if (params.extraAssets !== undefined) {
      this.extraAssets = params.extraAssets;
    }
    params.scene.add.existing(this);

    this.offState = this.scene.add.image(this.x, this.y, params.texture, 'off.png');
    this.offState.setVisible(false);

    this.updateView();

    this.setInteractive();
    this.on('pointerdown', this.pointerDown);
  }

  pointerDown () {
    // console.log('SpriteButton.pointerDown: ' + this);
    // for 'clicks'
    this.on('pointerup', this.pointerUp);
    // for 'drag out'
    this.scene.currentButton = this;
    this.scene.input.on('pointerup', this.pointerOut);
  }

  pointerUp (pointer, localX, locaY, event) {
    // console.log('SpriteButton.pointerUp: ', event);
    this.isOn = !this.isOn;
    this.updateView();
    // clean up listeners
    this.off('pointerup', this.pointerUp);
    this.scene.input.off('pointerup', this.pointerOut);
    // click action
    this.onClick.call(this.onClickScope);
    // prevent scene from getting this event too since it was on the button
    event.stopPropagation();
  }

  updateView () {
    if (this.isOn === false) {
      this.alpha = 0.01;
      this.offState.setVisible(true);
    } else {
      this.alpha = 1;
      this.offState.setVisible(false);
    }
  }
  // reset the button since the scene got this and the button did not.
  pointerOut () {
    let g = this.scene.currentButton;
    // console.log('SpriteButton.pointerOut: ', g);
    // clean up listeners
    g.off('pointerup', g.pointerUp);
    g.scene.input.off('pointerup', g.pointerOut);
  }

  hide () {
    this.scaleX = this.scaleY = this.offState.scaleX = this.offState.scaleY = 0;
  }

  open (delay = 0) {
    this.scaleX = this.scaleY = this.offState.scaleX = this.offState.scaleY = 0;
    this.alpha = 1;
    this.scene.tweens.add({
      targets: [this, this.offState],
      scaleX: 1,
      scaleY: 1,
      ease: 'Back.easeOut',
      duration: 300,
      delay: delay
    });
    if (this.extraAssets !== undefined) {
      for (let asset of this.extraAssets) {
        asset.scaleX = asset.scaleY = 0;
      }
      this.scene.tweens.add({
        targets: this.extraAssets,
        scaleX: 1,
        scaleY: 1,
        ease: 'Back.easeOut',
        duration: 300,
        delay: delay
      });
    }
  }
}

export default ToggleButton;
